import React, { useState, useCallback } from 'react';
import {debounce} from 'lodash';
import { Slider, Switch, Checkbox, Select,Space, Input, Tooltip, Typography, Tag } from 'antd';
import {RiFilter3Line, RiSearchLine} from "@remixicon/react";
import {FilterOutlined} from "@ant-design/icons";
import { getRange, getUniqueValues } from './utils';
const { Text } = Typography;



export const ComponentTitle = ({title})=>{
    return <div style={{
        fontSize: '14px',
        fontWeight: '500',
        color: '#000',
        fontFamily: 'Inter, sans-serif',
        textTransform: 'capitalize'
    }}>
        {title || ''}
    </div>
}


const tagRender = (props) => {
  const { label, value, closable, onClose } = props;
  const onPreventMouseDown = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };
  return (
    <Tag
      color={'blue'}
      onMouseDown={onPreventMouseDown}
      closable={closable}
      onClose={onClose}
      style={{
        marginRight: 3,
      }}
    >
      {label}
    </Tag>
  );
};

const FilterComponent = ({ config, data, onFilterChange }) => {
  // Determine the initial value based on the filter type and optional init property
  const initialValue = config.init !== undefined ? config.init : getDefaultValue(config, data);
  const [value, setValue] = useState(initialValue);
  const [searchTerm, setSearchTerm] = useState('');


  const debouncedOnFilterChange = useCallback(debounce((key, newValue) => {
        onFilterChange(key, newValue);
    }, 500), []);


  // Helper function to determine the default value based on filter type
  function getDefaultValue(config, data) {
    switch (config.type) {
      case 'number':
        return getRange(data, Array.isArray(config.key) ? config.key : [config.key]);
      case 'bool':
        return false; // Default boolean value
      case 'category':
        // For category, if multi is true, default to empty array; otherwise, use the first unique value or null
        return config.multi ? [] : getUniqueValues(data, config.key)[0] || null;
      default:
        return null;
    }
  }

  // Handler to reset the filter to its initial state
  const handleReset = () => {
    setValue(initialValue);
    onFilterChange(config.key, initialValue);
  };

  let inputElement = null;

  switch (config.type) {
    case 'number':
        let minmax = getRange(data, Array.isArray(config.key) ? config.key : [config.key]);
        let range = minmax[1] - minmax[0];
        let step = range/100;
        let defValues = [minmax[0] + step*3, minmax[1]]
        inputElement = (
            <Slider
                range
                defaultValue={minmax}
                value={value}
                onChange={setValue}
                min={minmax[0]}
                max={minmax[1]}
                step={step}
                className={'pt-4'}
                onChangeComplete={value => onFilterChange(config.key, value)}
            />
      );
      break;
    case 'bool':
      inputElement = (
        <Switch
          checked={value}
          onChange={(checked) => {
            setValue(checked);
            onFilterChange(config.key, checked);
          }}
        />
      );
      break;
    case 'category':
      const options = getUniqueValues(data, config.key).map(value => ({ label: value, value }));
        inputElement = <Select
                            mode={config.multi ? 'multiple' : undefined}
                            style={{ width: '100%', background: '#F5F7FE' }}
                            options={options}
                            value={value}
                            tagRender={tagRender}
                            placeholder={config?.placeholder??'Choose Options..'}
                            onChange={(selected) => {
                              setValue(selected);
                              onFilterChange(Array.isArray(config.key) ? config.key.join('.') : config.key, selected);
                            }}
                          />
      break;

    case 'search':
      inputElement = (
        <Input
          placeholder={config?.placeholder??'Enter Here..'}
          value={value} // This should reflect the immediate state to ensure the input updates as the user types
          onChange={(e) => {
            const newValue = e.target.value;
            setValue(newValue); // Update the input state immediately for responsiveness
            debouncedOnFilterChange(config.key, newValue); // Use the debounced function for delayed filter update
          }}
          prefix={<RiSearchLine size={16}/>}
        />
      );
      break;
    default:
      inputElement = null;

  }

  return (
    <div>
        <Space align="start" className="px-2" style={{ display: 'flex', alignItems: 'center' }}>
          <div>
              <ComponentTitle title={config.title || ''}/>
          </div>
        </Space>
        <div style={{ padding: '8px 0' }}>{inputElement}</div> {/* Adjust padding as needed */}
    </div>
  );
};

export {FilterComponent};
